// Matches a complete <script> ELEMENT: opening tag (`<script>`, `<script
// src=...` — but not e.g. `<scripting`), content, closing tag. Matching the
// whole element (not bare `<script` occurrences) keeps the stamp off script
// CONTENT — e.g. `document.write("<script src='x'>")` inside an inline
// script must not be touched: the inserted quotes would terminate the JS
// string literal and syntax-error the retailer's whole script. An unescaped
// literal `</script>` inside content ends the element here exactly like the
// HTML parser would.
const SCRIPT_ELEMENT = /(<script(?=[\s/>])[^>]*>)([\s\S]*?<\/script\s*>)/gi;

// CSP nonces are base64; anything else would break out of the attribute.
const UNSAFE_NONCE_CHARS = /[^A-Za-z0-9+/=_-]/g;

/**
 * Stamps the per-request CSP nonce onto every <script> element in an HTML
 * string.
 *
 * Used for retailer-configured HTML (header, banners) that sutro renders via
 * dangerouslySetInnerHTML: these scripts are part of the product, so they get
 * sutro's nonce and keep working under an enforced
 * `script-src 'nonce-…' 'strict-dynamic'` policy. The nonce is inserted as
 * the first attribute; if the markup already carries a nonce attribute, the
 * parser keeps the first one (ours). Only the opening tag is modified —
 * script content passes through byte-for-byte.
 */
export function stampScriptNonce(
  html: string,
  nonce: string | undefined,
): string {
  if (!html || !nonce) return html;
  const safeNonce = nonce.replace(UNSAFE_NONCE_CHARS, '');
  if (!safeNonce) return html;
  return html.replace(
    SCRIPT_ELEMENT,
    (_match, openTag: string, rest: string) =>
      `${openTag.replace(/^<script/i, (tag) => `${tag} nonce="${safeNonce}"`)}${rest}`,
  );
}
